import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { APIGestaCardService } from '../api/gestacard.service';
import { AlertsService } from 'app/shared/alerts.service';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private injector: Injector,
    private router: Router,
    private snackService: AlertsService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Desconsiderar erros na rota de menu "/api/menu"
        if (request.url.includes('/api/menu')) {
          return throwError(error);
        }

        if (error.status === 401) {
          
          if (error.error && error.error.accessTokenExpired) {
            // Lazy inject para evitar dependência circular
            const apiService = this.injector.get(APIGestaCardService);
            
            // Converte Promise para Observable e refaz requisição
            return from(apiService.GetNewAccessToken()).pipe(
              switchMap(() => {
                // Pega o novo token
                const newToken = localStorage.getItem('accessToken');
                
                // Clona a requisição com o novo token
                const clonedRequest = request.clone({
                  setHeaders: {
                    Authorization: newToken ? `Bearer ${newToken}` : ''
                  }
                });
                
                this.snackService.SnackMessage('Token atualizado.');
                
                // Refaz a requisição original com o novo token
                return next.handle(clonedRequest);
              }),
              catchError((refreshError) => {
                this.Logout();
                return throwError(refreshError);
              })
            );
          } else {
            this.Logout();
            return throwError(error);
          }

        }

        return throwError(error);
      })
    );

  }

  Logout() {
    localStorage.removeItem('medicoLogado')
    localStorage.removeItem('secretariaHash')
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    this.router.navigateByUrl('/auth/login')
  }
}
